<template lang="pug">
v-app-bar.header(
  dark
  color="accent"
  dense
  app
  clipped
  clipped-left
  elevation="0"
)
  v-app-bar-nav-icon.rounded(dark @click.stop="$emit('toggle-drawer')")
  v-toolbar-title.pl-0
    v-icon.mr-2 mdi-city-variant-outline
    | Офис ЦМ
  v-spacer
  a(@click.prevent="logout" href="/login")
    v-btn.rounded(dark icon small)
      v-icon(small) mdi-exit-to-app
</template>
<script>
import { mapActions } from 'vuex';

export default {

  methods:{
    ...mapActions({
      authLogout:'auth/logout',
    }),

    logout() {
      this.authLogout();
      this.$router.push('/login');
    },

  },
};
</script>

<style>

</style>
